import { faker } from '@faker-js/faker'

import {
  ServiceOfferMedicalCasesQuery,
  ServiceOfferMedicalCaseView,
} from '../../contracts/service-offer/MedicalCaseUserView'

export const mockServiceOfferMedicalCasesQuery = (): ServiceOfferMedicalCasesQuery => ({
  filter: {
    hospitalId: faker.number.int(),
  },
  pagination: {
    pageSize: faker.number.int(),
    pageIndex: faker.number.int(),
  },
})

export const mockServiceOfferMedicalCaseView = (): ServiceOfferMedicalCaseView => ({
  id: faker.number.int(),
  title: faker.lorem.sentence(),
  thumbnail: faker.image.url(),
  price: {
    currency: faker.finance.currencyCode(),
    originalAmount: faker.number.int(),
    discountedAmount: faker.number.int(),
    discountPercentage: faker.number.int(),
  },
  available: faker.datatype.boolean(),
  rating: {
    totalRating: faker.number.int(),
    ratingCount: faker.number.int(),
  },
  country: faker.location.countryCode(),
  hospital: {
    id: faker.number.int(),
    name: faker.company.name(),
    district: faker.location.city(),
    customerCertified: faker.datatype.boolean(),
    country: faker.location.countryCode(),
  },
  medicalCases: [
    {
      beforePhoto: {
        url: faker.image.url(),
      },
      afterPhoto: {
        url: faker.image.url(),
      },
      daysAfter: faker.number.int(),
      description: faker.lorem.sentence(),
    },
  ],
  treatments: [
    {
      id: faker.number.int(),
    },
  ],
})
